import { useFeatureFlags } from 'utils/features';

export default function useAutomaticBreaksEnabled() {
  return useFeatureFlags('AUTOMATIC_BREAKS');
}
